<template>
    <el-tabs v-model="activeName" @tab-click="clickEvent">
        <el-tab-pane label="收款对账单列表" name="1" link="/finance/statement/list"></el-tab-pane>
        <el-tab-pane label="异常收入对账处理" name="2" link="/finance/statement/abnormal/list"></el-tab-pane>
        <el-tab-pane label="重复支付订单" name="3" link="/finance/statement/repeatOrder/list"></el-tab-pane>
    </el-tabs>
</template>

<script>
export default {
    props:{
        name:{
            type: String,
            default:  "1"
        }
    },
    data(){
        return{
            activeName: this.name,
        }
    },
    methods: {
        clickEvent(tab) {
            if (tab.$attrs.link) this.$router.push(tab.$attrs.link);
        },
    },
}
</script>